<!-- Maintenance - Savings disabled -->
@if (showMaintenance()) {
  <div class="text-center justify-center container-create-first padding-account">
    <!-- icon -->
    <div class="maintenance-icon bpi__icon-time mb-20"></div>
    <!-- text -->
    <div class="font-size-20 mb-10 maintenance-text">
      <strong>{{ "savings_plan_maintenance_title" | translate }}</strong>
    </div>
    <div class="text-gray mb-20">{{ "savings_plan_maintenance_description" | translate }}</div>
  </div>
} @else {
  <!-- NO savings plans -->
  <div class="savings_component__empty_state_container new">
    <img src="assets/images/new_empty_savings_plan.svg" class="new-savings-icon" [alt]="'savings' | translate" />
    <div class="font-size-20 large-weight pb-5 title">
      {{ "new_savings_widget_header_title" | translate }}
    </div>
    <div class="font-size-15 savings_component__empty_state_text">
      {{ "new_savings_widget_header_subtitle" | translate }}
    </div>
    <button class="savings_component__empty_state_button_new btn btn-primary" (click)="triggerNewSavingsPlan()">
      {{ "savings_plan_with_plans_create_new" | translate }}
    </button>
  </div>
}
